/* BA Mystery Necklace GWP — minimal auto-add v2.
 * No banner. No customer click. No quantity/remove edits. Adds once, then refreshes once so cart drawer renders the gift.
 * Updated 2026-09-21 19:17 UTC.
 */
(function(){
  'use strict';
  if (window.__baGwpMinimalV2Loaded) return;
  window.__baGwpMinimalV2Loaded = true;
  var VARIANT_ID = 31819096981585;
  var THRESHOLD_CENTS = 10000;
  var syncing = false;
  var lastAttempt = 0;
  function api(path, opts){
    return fetch(path, Object.assign({credentials:'same-origin',headers:{'Accept':'application/json'}}, opts || {})).then(function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error(path+' '+r.status+' '+t); });
      return r.json();
    });
  }
  function isGift(item){ return item && Number(item.variant_id) === VARIANT_ID; }
  function paidSubtotal(cart){
    return (cart.items || []).reduce(function(sum,item){
      if(isGift(item)) return sum;
      return sum + Number(item.final_line_price || item.line_price || 0);
    }, 0);
  }
  function hasGift(cart){ return (cart.items || []).some(isGift); }
  function addGift(){
    return api('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:VARIANT_ID,quantity:1,properties:{'_BA GWP':'Free Mystery Necklace Gift on $100+ Orders'}})});
  }
  function showGift(){
    // One page refresh only after successful add. This avoids drawer-specific render bugs.
    setTimeout(function(){ window.location.reload(); }, 150);
  }
  function sync(reason){
    if(syncing) return;
    syncing = true;
    api('/cart.js').then(function(cart){
      if(paidSubtotal(cart) < THRESHOLD_CENTS) return;
      if(hasGift(cart)) return;
      var now = Date.now();
      if(now - lastAttempt < 3000) return;
      lastAttempt = now;
      return addGift().then(showGift);
    }).catch(function(e){ console.warn('[BA GWP minimal v2] skipped', reason || '', e); }).finally(function(){ syncing = false; });
  }
  function schedule(reason, delay){ setTimeout(function(){ sync(reason); }, delay || 600); }
  document.addEventListener('DOMContentLoaded', function(){ schedule('dom', 700); });
  window.addEventListener('focus', function(){ schedule('focus', 500); });
  document.addEventListener('cart:updated', function(){ schedule('cart-updated', 700); });
  document.addEventListener('cart:refresh', function(){ schedule('cart-refresh', 900); });
  document.addEventListener('theme:cart:reload', function(){ schedule('theme-cart-reload', 900); });
  document.addEventListener('click', function(){ schedule('click', 1300); }, true);
  document.addEventListener('change', function(){ schedule('change', 1300); }, true);
  if(window.fetch && !window.__baGwpMinimalV2FetchWrapped){
    var originalFetch = window.fetch;
    window.__baGwpMinimalV2FetchWrapped = true;
    window.fetch = function(){
      var args = arguments;
      var url = String(args[0] && (args[0].url || args[0]) || '');
      return originalFetch.apply(this, args).then(function(resp){
        if(/\/cart\/(add|change|update|clear)\.js/.test(url)) schedule('fetch-cart', 900);
        return resp;
      });
    };
  }
})();
